import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function TaskStatus({ status }: Props) {
  const { t } = useTranslation();
  return (
    <div
      className={styles.taskStatus}
      style={{ backgroundColor: status.color }}
    >
      <p className={styles.name}>
        {t(`taskStatuses.${status.label}`, status.label)}
      </p>
    </div>
  );
}

export { TaskStatus };
